import React from 'react';
import ReactDOM from 'react-dom';

import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileState from 'filestate/FileState';
import {EntryFileState, SubtemplateFileState, TemplateFileState} from 'FileStates';
import ResourcePresenceManager from 'nav/presence/ResourcePresenceManager';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import EntityStore from 'stores/EntityStore';

export default class PresenceManager {
  mount!: JQuery;
  mounted!: boolean;

  constructor(mount: JQuery) {
    assert(mount && mount.length === 1, 'expected realtime presence mount point');
    this.mount = mount;
    this.mounted = false;
  }

  subscribe(file: FileState | null): void {
    if (!presenceEnabled()) {
      this.unsubscribe();
      return;
    }

    const fileId = getResourceIdForRealtime(file);
    if (!fileId) {
      this.unsubscribe();
      return;
    }

    renderToDOM(<ResourcePresenceManager fileId={fileId} />, this.mount[0]);

    this.mounted = true;
  }

  unsubscribe(): void {
    if (this.mounted) {
      ReactDOM.unmountComponentAtNode(this.mount[0]);
      this.mounted = false;
    }
  }
}

function presenceEnabled(): boolean {
  return EntityStore.currentUser() != null;
}

/**
 * Returns a resource ID for the FileState if the resource type is supported by the realtime
 * presence system.
 *
 * @param fileState the FileState
 * @returns the resource ID (API identifier) or null if the folder item is null or not supported by presence.
 */
export function getResourceIdForRealtime(fileState: FileState | null): string | null {
  let id: string | null = null;
  if (!fileState) {
    return null;
  }

  switch (fileState.fileType()) {
    case ModelTypeConstants.ENTRY:
    case ModelTypeConstants.TEMPLATE:
      ({id} = (fileState as EntryFileState | TemplateFileState).model());
      break;
    case ModelTypeConstants.SUBTEMPLATE:
      if (!BenchlingConfig.ELN_REALTIME_TEMPLATE_UPDATES) {
        return null;
      }
      ({id} = (fileState as SubtemplateFileState).model());
      break;
    default:
      return null;
  }

  return id;
}
